import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { SocialProofSection } from '../components/SocialProofSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { EarlyBirdSection } from '../components/EarlyBirdSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { PromoBanner } from '../components/PromoBanner';

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-background" data-testid="landing-page">
      <Navbar />
      <HeroSection />
      <EarlyBirdSection />
      <PromoBanner variant="landing" />
      <SocialProofSection />
      <ProblemSection />
      <SolutionSection />
      <FinalCTA />
      <Footer />
    </div>
  );
}
